
<!--
<div class="kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm no-print">
    
    <div class="kt-portlet__head-label">
        <h3 class="kt-portlet__head-title">
        </h3>
    </div>
</div>
-->

<div class="kt-portlet__body kt-padding-10 ticket-container">

    <div *ngIf="ticket != null" >
        
        <div class="ticket-header sticky-top">

            <h2 class="kt-label-font-color-4">
                &#35;{{ ticket?.public_id }}  
                <charla-priority [priority]="ticket?.priority" (change)="save_priority($event)"></charla-priority>                    

                {{ ticket?.subject }}
            </h2>

            <div class="ticket-actions row justify-content-between">
                <div class="align-items-center col-sm-auto">

                    <div class="row align-items-center" >
                        <div class="col-sm-auto border-end">
                            <charla-ticket-status [status]="ticket?.status" [post]=" (ticket && ticket.closed_at) ? (ticket.closed_at | amFromUtc  | amLocal | amDateFormat: 'DD MMM h:mm a') : '' "></charla-ticket-status>
                        </div>
                        <div class="col-sm-auto border-end">
                            <div class="from">
                                <charla-avatar class="recipient" [visitor_id]="ticket?.recipient?.id" [pic]="ticket?.recipient?.profile_pic" size="25px"></charla-avatar>
                                <div>
                                    <span *ngIf="ticket?.recipient?.name">{{ ticket?.recipient?.name }}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon email">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect id="bound" x="0" y="0" width="24" height="24"/>
                                            <path d="M5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z" id="Combined-Shape" fill="#000000"/>
                                        </g>
                                    </svg>
                                    {{ ticket?.recipient?.email }}
                                </div>    
                            </div>
                        </div>
                        <div class="col-sm-auto border-end">
                            <span class="date_created">{{ 'inbox.components.ticket.value_via_value2' | t:'{{value}} via {{value2}}':{value: (ticket?.created_at | amFromUtc  | amLocal | amDateFormat: 'DD MMM h:mm a'), value2: (ticket?.source | ticketSource)} }}</span>
                        </div>
                        <div class="col-sm-auto">
                            <tag-editor [selected]="ticket?.tags" [tags]="tags$ | async" (Save)="save_tags($event)" color="#a2a5b9" ></tag-editor>
                        </div>
                    </div>
                </div>

                <div class="align-items-center col-sm-auto">
                    <div class="row align-items-center"> 

                        <div class="col-sm-auto border-end">
                            <charla-assignee [selected]="ticket?.assignees" [agents]="agents$| async" (Save)="save_assignees($event)"></charla-assignee>
                        </div>
                        <div class="col-sm-auto border-end">
                            <charla-property-label [name]="ticket?.property.name" [showLabel]="false"></charla-property-label>
                        </div>
                        <div class="col-sm-auto" *ngIf="ticket?.status != 3">
                            <button class="btn btn-sm btn-success" type="button" (click)="update_status(3)">{{ 'inbox.components.ticket.close_ticket' | t:'Close Ticket' }}</button>
                        </div>
                        <div class="col-sm-auto" *ngIf="ticket?.status == 3">
                            <button class="btn btn-sm btn-secondary" type="button" (click)="update_status(2)">{{ 'inbox.components.ticket.reopen_ticket' | t:'Reopen Ticket' }}</button>
                        </div>
                        <div class="col-sm-auto" *hasRole="['Team Member','Account Owner', 'Charla Admin']">

                            <div ngbDropdown autoClose="outside">
                                <button class="more btn btn-secondary btn-hover-brand btn-sm" ngbDropdownToggle [title]="'inbox.components.ticket.more_actions' | t:'More Actions'">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13.6px" height="4px" viewBox="0 0 13.6 4" version="1.1" class="kt-svg-icon">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect id="bound" x="0" y="0" width="13.6" height="4"/>
                                            <path id="Combined-Shape" class="st1" d="M1.8,3.5C1,3.5,0.3,2.8,0.3,2S1,0.5,1.8,0.5S3.3,1.1,3.3,2S2.6,3.5,1.8,3.5z M6.8,3.5 C6,3.5,5.3,2.8,5.3,2S6,0.5,6.8,0.5S8.3,1.1,8.3,2S7.6,3.5,6.8,3.5zM11.8,3.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S12.6,3.5,11.8,3.5z" fill="#000000" />                                    
                                        </g>
                                    </svg>
                                </button>                    
                                
                                <div ngbDropdownMenu>
                                    <button ngbDropdownItem class="btn-delete-ticket" [ngbPopover]="deleteConfirmation" [popoverTitle]="'inbox.components.ticket.confirm_deletion' | t:'Confirm Deletion'" placement="left" popoverClass="charla-confirm-popup" >
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <rect id="bound" x="0" y="0" width="24" height="24"/>
                                                <path d="M6,8 L6,20.5 C6,21.3284271 6.67157288,22 7.5,22 L16.5,22 C17.3284271,22 18,21.3284271 18,20.5 L18,8 L6,8 Z" id="round" fill="#000000" fill-rule="nonzero"/>
                                                <path d="M14,4.5 L14,4 C14,3.44771525 13.5522847,3 13,3 L11,3 C10.4477153,3 10,3.44771525 10,4 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z" id="Shape" fill="#000000" opacity="0.3"/>
                                            </g>
                                        </svg>
                                        <span>{{ 'inbox.components.ticket.delete_ticket' | t:'Delete Ticket' }}</span>
                                    </button>
                                </div>   
                            </div>
                        </div>
                        <div class="col-4"></div>

                    </div>
                </div>
            </div>

        </div>

        <div class="row ticket-details">
          
            <div [ngClass]="showSidebar ? 'col-md-8' : 'col-md-12'" class="border-end replies overflow-auto">

                <div class="reply-container kt-label-font-color-4">
                    
                    <div class="from">
                        <img  [src]="(current_user$ | async)?.photo" />
                    </div>

                    <div class="reply" >

                        <form [formGroup]="form_reply" class="kt-form kt-form--label-right" (ngSubmit)="save_reply()">    
                            <div class="from">{{ 'inbox.components.ticket.from' | t:'From' }} 
                                <span class="from-email">
                                    {{ (current_user$ | async)?.fullname + " &lt;" + ( (ticket?.property?.email_from) ? (ticket?.property?.email_from) : (ticket?.property?.email_alias + "@inbox.getcharla.com") ) + "&gt;" }}
                                </span>
                                <span *ngIf="!(ticket?.property?.email_from)" placement="right" [ngbTooltip]="tipSendFrom"  [closeDelay]="100000" tooltipClass="tooltip-dark" >
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect id="bound" x="0" y="0" width="24" height="24"/>
                                            <circle id="Oval-5" fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                                            <rect id="Rectangle-9" fill="#000000" x="11" y="10" width="2" height="7" rx="1"/>
                                            <rect id="Rectangle-9-Copy" fill="#000000" x="11" y="7" width="2" height="2" rx="1"/>
                                        </g>
                                    </svg>
                                </span>
                            </div>
                            <div class="to">{{ 'inbox.components.ticket.to' | t:'To' }} <span class="to-email">{{ ticket?.recipient?.email }}</span></div>
                            <div class="to">{{ 'inbox.components.ticket.cc' | t:'Cc' }} <rocket-edit class="to-email" mode="emails" [empty]="'common.add' | t:'Add'" [value]="form_reply.get('cc').value" (Save)="update_cc($event)" [title]="'inbox.components.ticket.add_cc' | t:'Add Cc'"></rocket-edit>
                                <input type="hidden" formControlName="cc" value="" />
                            </div>
                            <div class="naked-skin-container">
                                <editor
                                    [init]="tiny_config"
                                    (onInit)="onEditorReady($event)"
                                    formControlName="content"
                                    plugins="advlist autolink lists preview anchor searchreplace visualblocks codesample table code autoresize"
                                    toolbar="languageButton refreshlanguagebutton |formatselect | bold italic backcolor | bullist numlist outdent indent | removeformat | link table codesample"
                                    (onBlur)="updateTranslation()"
                                    >
                                </editor> 
                            </div>
                            <button #popoverTranslate="ngbPopover"
                                [ngbPopover]="selectLanguage"
                                [popoverTitle]="'inbox.components.ticket.live_translations' | t:'Live Translations'"
                                placement="bottom"
                                popoverClass="charla-confirm-popup nudget-bottom"
                                [autoClose]="'outside'" type="button" class="popover-placeholder">
                            </button>
                            
                            <div class="row kt-margin-b-10" *ngIf=" content_translated" >
                                <div class="col-auto" [title]="'inbox.components.ticket.text_will_be_automatically_translated' | t:'Text will be automatically translated. This is what your customer will receive.'">🌍</div>
                                <div class="col-auto border-start" [innerHTML]="content_translated">         
                                </div>
                            </div>

                            <div class="row justify-content-between">
                                <div class="col">
                                    <div class="kt-checkbox-list">
                                        <label class="kt-checkbox kt-checkbox--solid">
                                                <input type="checkbox" formControlName="is_private" [value]="false"> {{ 'inbox.components.ticket.private_reply' | t:'Private Reply' }} 
                                                <span></span>
                                        </label>								
                                    </div>
                                    <div class="attachment" *ngFor="let attachment of pending_attachments" 
                                        [ngStyle]="{ 'background': 'linear-gradient(to right, #f0f3ff, #f0f3ff  ' +  attachment.upload_progress + '%, #fff ' + attachment.upload_progress + '%, #fff)'}">
                                        <div class="attachment-name">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                    <polygon id="Shape" points="0 0 24 0 24 24 0 24"/>
                                                    <path d="M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z" id="Combined-Shape" fill="#000000" fill-rule="nonzero" opacity="0.3"/>
                                                    <rect id="Rectangle" fill="#000000" x="6" y="11" width="9" height="2" rx="1"/>
                                                    <rect id="Rectangle-Copy" fill="#000000" x="6" y="15" width="5" height="2" rx="1"/>
                                                </g>
                                            </svg>
                                            <span>{{ attachment.filename }}</span>
                                        </div>
                                        <div>
                                            <button type="button" class="attachment-cancel" (click)="cancel_upload(attachment)">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                        <g id="Group" transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                                            <rect id="Rectangle-185" x="0" y="7" width="16" height="2" rx="1"/>
                                                            <rect id="Rectangle-185-Copy" opacity="0.7" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) " x="0" y="7" width="16" height="2" rx="1"/>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </button>
                                        </div>
                                
                                    </div>
                                </div>
                                <div class="col text-right">
                                    <span>
                                        <a (click)="fileUpload.click()" class="upload-button" [title]="'inbox.components.ticket.attach_file' | t:'Attach File'">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" class="kt-svg-icon">
                                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                    <path d="M33 12v23c0 4.42-3.58 8-8 8s-8-3.58-8-8v-25c0-2.76 2.24-5 5-5s5 2.24 5 5v21c0 1.1-.89 2-2 2-1.11 0-2-.9-2-2v-19h-3v19c0 2.76 2.24 5 5 5s5-2.24 5-5v-21c0-4.42-3.58-8-8-8s-8 3.58-8 8v25c0 6.08 4.93 11 11 11s11-4.92 11-11v-23h-3z" fill="#000000" />
                                                </g>
                                            </svg>
                                        </a>	
                                        <input type="file" multiple class="file-input" (change)="onFileSelected($event)" #fileUpload>		
                                    </span>	


                                    <!--
                                        <div class="btn-group">
                                                <button type="button" class="btn btn-primary">Primary</button>
                                                <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <span class="sr-only">Toggle Dropdown</span>
                                                </button>
                                                <div class="dropdown-menu" x-placement="bottom-start" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(76px, 37px, 0px);">
                                                    <a class="dropdown-item" href="#">Action</a>
                                                    <a class="dropdown-item" href="#">Another action</a>
                                                    <a class="dropdown-item" href="#">Something else here</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" href="#">Separated link</a>
                                                </div>
										</div>
                                    -->
                                    <div class="btn-group">
                                        <div class="btn-group" ngbDropdown role="group" container="body"  >
                                            <button type="submit" class="btn btn-brand btn-bold btn-sm send"  [disabled]="(sending$ | async) || (upload_inprogress$ | async)" 
                                                [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': (sending$ | async)}">
                                                {{ (sending$ | async) ? ('inbox.components.ticket.sending_reply' | t:'Sending Reply...') : ('common.send' | t:'Send') }}
                                            </button>
                                            <button type="button" class="btn btn-primary dropdown-toggle-split" ngbDropdownToggle >
                                                <span [inlineSVG]="'Navigation/Angle-down.svg'" class="svg-white" [setSVGAttributes]="{width: '16px'}" ></span>
                                            </button>
                                            <div class="dropdown-menu" ngbDropdownMenu>
                                                <button ngbDropdownItem (click)="save_reply(TicketStatus.InProgress)">{{ 'inbox.components.ticket.send_keep_in_progress' | t:'Send & Keep In Progress' }}</button>
                                                <button ngbDropdownItem (click)="save_reply(TicketStatus.Resolved)">{{ 'inbox.components.ticket.send_mark_resolved' | t:'Send & Mark Resolved' }}</button>
                                                <button ngbDropdownItem (click)="save_reply(TicketStatus.Closed)">{{ 'inbox.components.ticket.send_mark_closed' | t:'Send & Mark Closed' }}</button>
                                            </div>
                                        </div>
                                    </div>

                                    <!--
                                      <button class="btn btn-brand btn-sm btn-bold send" [disabled]="(sending$ | async) || (upload_inprogress$ | async)" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': (sending$ | async)}" type="submit">
                                   
                                        
                                    </button> -->
                                
                                </div>
                            </div>

                        </form>
                
                    </div>

                </div>


                <div class="reply-container kt-label-font-color-4" *ngFor="let reply of ticket?.replies" [ngClass]="{ 'highlight' : highlight == reply.id, 'private': reply.is_private }">
                    <div class="from">
                        <img *ngIf="reply.from_agent" [src]="reply.from_agent?.photo"  />
                        <charla-avatar *ngIf="reply.from_visitor" [visitor_id]="reply.from_visitor.id" [pic]="reply.from_visitor.profile_pic" size="40px"></charla-avatar>
                        <button *ngIf="reply.from_visitor" class="btn btn-clean btn-sm btn-bold translate" (click)="translateReply(reply.id, reply.content)" [title]="'Translate reply to your Profile language (' + (current_user$ | async)?.live_translation_language + ')'">
                            <img src="/assets/media/icons/translate-outline.svg"  /> 
                        </button>
                    </div>

                    <div class="reply">
                        <div>{{ reply.from_agent?.fullname }}</div>
                        <div>{{ reply.from_visitor?.name}} {{ reply.from_visitor?.email}} </div>
                        <div *ngIf="reply.cc"><strong>{{ 'inbox.components.ticket.cc_2' | t:'Cc:' }} </strong>{{ reply.cc | formatcc}}</div>

                        <div class="date kt-label-font-color-3">{{ reply.created_at | amFromUtc  | amLocal | amTimeAgo }}</div>

                        <div class="reply-attachments" *ngIf="reply.attachments">
                            <div *ngFor="let attachment of reply.attachments" >
                                <charla-attachment [name]="attachment" container="tickets-attachments" class="attachment-ticket"></charla-attachment>
                            </div>
                        </div>

                        <div class="reply-content">
                            <charla-ticket-content [content]="reply.content"></charla-ticket-content>
                            <div *ngIf="reply.content_translated"  class="row kt-margin-t-10"> 
                                <div class="col-auto" [title]="'inbox.components.ticket.live_translation' | t:'Live Translation'">🌍</div>
                                <div class="col-auto border-start" [innerHTML]="reply.content_translated"></div>
                            </div>
                        </div>

                    </div>
                    

                </div>

            </div>

            <div class="col-md-4" *ngIf="showSidebar">
                <div class="sticky-top pt-4 contact-panel">
                    <charla-contact-edit [contact]="ticket?.recipient" [ticket_id]="ticket?.id" use_store="tickets" [show_conversations]="true" [show_tickets]="false"></charla-contact-edit>
                </div>
            </div>

        </div>





    </div>


</div>



<ng-template #deleteConfirmation>
    {{ 'inbox.components.ticket.are_you_sure_you_want_to' | t:'Are you sure you want to delete this Ticket?' }}
    <div class="kt-align-right kt-margin-t-10">
        <span class="kt-margin-r-10"><a [routerLink]="[]" class="kt-link kt-font-bold">{{ 'common.cancel' | t:'Cancel' }}</a> {{ 'inbox.components.ticket.or' | t:'or' }}</span>
        <button class="btn btn-danger" (click)="delete_ticket()" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': delete_loading$ | async}" type="button">{{ (delete_loading$ | async) ? ('inbox.components.ticket.deleting' | t:'Deleting...') : ('common.delete' | t:'Delete') }}</button>		
    </div>
</ng-template>   


<ng-template #tipSendFrom>
    {{ 'inbox.components.ticket.use_your_own_domain_by_setting' | t:'Use your own domain by setting the Send As field under the Tickets section in the' }} <a [routerLink]="['/settings/properties', ticket?.property?.id]" fragment="tickets">{{ 'common.settings' | t:'Settings' }}</a> {{ 'inbox.components.ticket.page' | t:'page' }}
</ng-template>

<ng-template #selectLanguage>
    <charla-live-translation [visitor]="ticket?.recipient" [popover]="popoverTranslate" (on)="applyLiveTranslation($event)" (off)="stopLiveTranslation()"></charla-live-translation>
</ng-template>

